import React, { useEffect, useRef } from 'react';
import './whyWonderaly.scss';

const WhyWonderaly = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="whyWonderaly-info">
      <div className="whyWonderaly-info__content">
        <div className="whyWonderaly-info__section">
          <h2 className="content__title-backgroundWhite">
            Donde la ciencia encuentra el arte
          </h2>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <h3 className="content__subtitle-backgroundWhite">
            El valor de elegirnos
          </h3>
          <p className="content__text-title-backgroundWhite">
            En WONDERALY INNOVATIONS, creemos que la neuropsicología es la clave
            para llevar la producción audiovisual a un nivel superior, creando
            experiencias cinematográficas que conectan profundamente con el
            espectador.
          </p>
        </div>
        <div className="whyWonderaly-info__section">
          <p className="content__text-paragrah-backgroundWhite">
            Por eso, desarrollamos soluciones basadas en neuropsicología
            aplicada, Inteligencia Artificial (IA) y Business Intelligence (BI)
            especialmente pensadas para las necesidades de la industria
            audiovisual. Optimizamos guiones, personajes y dinámicas de equipo,
            convertimos datos emocionales en conocimiento accionable y ayudamos
            a nuestros clientes a tomar decisiones más creativas, precisas y
            estratégicas.
          </p>
          <p className="content__text-paragrah-backgroundWhite">
            Elegir WONDERALY INNOVATIONS significa apostar por la innovación
            aplicada con sentido, integrando ciencia y arte en cada proyecto. No
            solo asesoramos: nos sumergimos en cada producción para generar un
            impacto real y medible. Con nuestro enfoque, las productoras y
            equipos creativos no solo compiten en un mercado exigente, sino que
            lideran la transformación de la industria audiovisual con confianza
            y visión de futuro.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyWonderaly;
